import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import { useTranslation } from 'react-i18next';
import { PrimaryButton } from '../../../components';
export const ErroDialog = (props) => {
    const { t } = useTranslation();
    const { children, isOpen, title, closeLabel = t('閉じる'), onClose } = props;
    return (React.createElement(Dialog, { open: isOpen, fullWidth: true, onClose: onClose },
        React.createElement(DialogTitle, null, title),
        React.createElement(DialogContent, null,
            React.createElement(DialogContentText, null, children)),
        React.createElement(DialogActions, null,
            React.createElement(PrimaryButton, { onClick: onClose }, closeLabel))));
};
